import React, { Component } from 'react';
import Toolbar from './components/Toolbar/Toolbar';
import BackDrop from './components/BackDrop/BackDrop';
import { BrowserRouter as Router, Route, Switch, Redirect, HashRouter } from 'react-router-dom';
import Dashboard from './containers/Dashboard/Dashboard';

// import Api from './Services/AllServices';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }



  componentDidMount() {
  }


  render() {
    return (
        <div style={{ height:'100%'}}>
          {/* <Toolbar drawerClickHandler={this.handleSideDrawerClick} clickLogout={this.alertLogout} cartNumber={this.state.number} userEmail={this.state.userEmail} /> */}
            <div>
            {/* <SideDrawer show={this.state.sideDrawerOpen} clickLogout={this.alertLogout} cartNumber={window.localStorage.getItem('CartNum')} userEmail={this.state.userEmail} /> */}
              <HashRouter>
                  <Route exact path="/:Data" component={Dashboard} />  
                  <Route render={() => (<Redirect to="/:Data" />)} />
              </HashRouter>
            </div>
        </div>

    );
  };

}

export default App;
